export default __webpack_public_path__ + "static/media/bg-slim-banner.92ef9892.png";